import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router-dom'
import { SharedCampaignContext } from '../../../../../../contexts/Advertiser/SharedCampaignContext'
import axiosService from '../../../../../../utils/AxiosService'
import DraftComment  from '../../../../../../models/DraftComment'
import { CheckCircle } from 'react-bootstrap-icons'
import LinkifiedText from '../../../../../Shared/LinkifiedText'


export default observer(function CommentItemsSidebar({ location }) {
  const { selectedUpload } = useContext(SharedCampaignContext)
  const { id, action_id } = useParams()
  const [comments, setComments] = useState([])
  const [isAccepted, setIsAccepted] = useState(location.isAccepted)
  const [unroll, setUnroll] = useState(false)

  const getComments = () => {
    axiosService.get(`/api/project_manager/campaigns/${id}/actions/${action_id}/draft_uploads/${selectedUpload.id}/draft_comment_locations/${location.id}/draft_comments`)
      .then(comments => {
        console.log(comments)
        setComments(comments.map(comment => new DraftComment(comment)))
      })
      .catch(error => console.log(error))
  }

  const handleAcceptComment = () => {
    setIsAccepted(true)
    axiosService.patch(
      `/api/project_manager/campaigns/${id}/actions/${action_id}/draft_uploads/${selectedUpload.id}/draft_comment_locations/${location.id}`,
      { location: { is_accepted: true } }
    )
      .then((updatedLocation) => {
        setTimeout(() => {
          selectedUpload.commentLocations = selectedUpload.commentLocations.filter(location => location.id !== updatedLocation.id)
        }, 200);
      })
      .catch(() => toastError('Could not accept comments'))
  }

  const CommentItem = ({ comment, inReplies }) => (
    <div className="mt-6">

      <div className='flex justify-between'>
        <img src={comment?.authorAvatar} alt={comment?.authorName} className="h-8 w-8 rounded-full object-cover mr-2" />
        {
          !inReplies && (
            <button onClick={handleAcceptComment} className="dark:text-white">
              <CheckCircle className={`${isAccepted ? 'text-rb-green dark:text-rb-green' : 'text-rb-mat-grey dark:text-gray-400'} text-md`} />
            </button>
          )
        }
      </div>

      <div className="flex gap-2 items-center">
        <p className="font-bold text-sm dark:text-white">{comment?.authorName}</p>
        <span className='text-xs text-rb-mat-grey dark:text-gray-400'>{comment?.postedAt}</span>
      </div>

      <div className='text-md text-rb-mat-grey dark:text-gray-400'><LinkifiedText text={comment?.comment} /></div>

    </div>
  )

  useEffect(() => getComments(), [selectedUpload.id])

  return (
    <div className='overflow-y-auto'>
      <CommentItem comment={comments[0]} />
      {
        !unroll && comments.length > 2 && (
          <button className='text-rb-green dark:text-rb-green' onClick={() => setUnroll(true)} >{comments.length - 1} replies</button>
        )
      }
      {
        !unroll && comments.length === 2 && (
          <button className='text-rb-green dark:text-rb-green' onClick={() => setUnroll(true)} >{comments.length - 1} reply</button>
        )
      }
      {
        unroll && (
          <div className='border-l-2 border-rb-green dark:border-rb-green pl-3'>
            {comments.slice(1).map(comment => <CommentItem comment={comment} inReplies/>)}
            <button className='text-rb-green dark:text-rb-green' onClick={() => setUnroll(false)} >(close)</button>
          </div>
        )

      }
    </div>
  )
})
